/**
 * Variables
 *
 * @type {Element}
 */
var buttonMenu = document.getElementsByClassName('button-menu')[0];
var buttonMenuTextClose = document.getElementsByClassName('button-menu__text_close')[0];
var buttonMenuTextMenu = document.getElementsByClassName('button-menu__text_menu')[0];
var isActiveMenu = 'button-menu_active';
var isOpenMenu = 'menu_open';
var isVisibleText = 'button-menu__text_visible';
var menu = document.getElementsByClassName('menu')[0];
var animateFlag = true
var header = document.getElementsByClassName("header_bar");
var headerBar = document.getElementById("headerBar");

/**
 * Event click on menu button
 */
buttonMenu.addEventListener('click', function() {

    if (this.classList.contains(isActiveMenu)) {
        this.classList.remove(isActiveMenu);
        closeMenu();
    } else {
        this.classList.add(isActiveMenu);
        openMenu();
    }

});

/**
 * Function opening menu
 */
function openMenu() {
    buttonMenuTextClose.classList.add(isVisibleText);
    buttonMenuTextMenu.classList.remove(isVisibleText);
    menu.classList.add(isOpenMenu);
    headerBar.classList.add("header_fixed");
}

/**
 * Function closing menu
 */
function closeMenu() {
    buttonMenuTextClose.classList.remove(isVisibleText);
    buttonMenuTextMenu.classList.add(isVisibleText);
    menu.classList.remove(isOpenMenu);
    headerBar.classList.remove("header_fixed");
}



function fillHeader() {
    if(this.pageYOffset > 0) {
        if(animateFlag) {
            header[0].classList.add("header_white");
            // animateFlag = false;
        }
    } else {
        header[0].classList.remove("header_white");
    }
}

if (header.length > 0) {
    fillHeader();
    window.addEventListener("scroll", function() {
        fillHeader();
    });
}

function openMenuAndFocus(inputId) {
    buttonMenu.classList.add(isActiveMenu);
    openMenu();
    setTimeout(function () {
        $('#'+inputId).trigger('focus');
    }, 1000);
}
